import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../../actions/ts_overlay_actions.js';
import {
  updateModal
} from '../../../actions/modal.js';
import {
  updateCanvas
} from '../../../actions/ts_canvas_actions.js';
import {
  changeStamp
} from '../../../actions/ts_stamp_actions.js';
import {
  Button,
  Modal,
  Grid,
  Row,
  Col,
  Clearfix,
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  Dropdown,
  Accordion,
  Panel,
  PanelGroup
} from 'react-bootstrap';
var Shapes = React.createClass({
  stampSelected(stamp) {
    var {
      dispatch,
      overlay
    } = this.props;
    dispatch(clearDraw(overlay.color, overlay.color1, overlay.color2));
    dispatch(changeStamp(stamp, 'white'));
    dispatch(updateModal(false, null));
  },

  render() {
    var {
      overlay,
      map,
      currentUser
    } = this.props;
    var cellStyle= "fa-lg pointerCursor";
    if(overlay.color == 'blue'){
      cellStyle ="fa-lg icon-blue pointerCursor";
    }
    if(overlay.color == 'red'){
        cellStyle ="fa-lg icon-red pointerCursor";
    }
    return (
        <div>
          <Grid>
          <Row>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u0E4F');}} className={cellStyle} >&#3663;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2295');}} className={cellStyle} >&#8853;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\uFF0B');}} className={cellStyle} >&#65291;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u20E0');}} className={cellStyle} >&#8416;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u24CD');}} className={cellStyle} >&#9421;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u20DD');}} className={cellStyle} >&#8413;</Col>
          </Row>
          <Row>
          <Col md={1} xs={2}><br/></Col>
          </Row>
          <Row>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2606');}} className={cellStyle} >&#9734;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u0024');}} className={cellStyle} >&#36;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u21D0');}} className={cellStyle} >&#8656;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u21D1');}} className={cellStyle} >&#8657;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u21D2');}} className={cellStyle} >&#8658;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u21D3');}} className={cellStyle} >&#8659;</Col>
          </Row>
          <Row>
          <Col md={1} xs={2}><br/></Col>
          </Row>
          <Row>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u21D6');}} className={cellStyle} >&#8662;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u21D7');}} className={cellStyle} >&#8663;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u21D8');}} className={cellStyle} >&#8664;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u21D9');}} className={cellStyle} >&#8665;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u0021');}} className={cellStyle} >&#33;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u003F');}} className={cellStyle} >&#63;</Col>
          </Row>
          <Row>
          <Col md={1} xs={2}><br/></Col>
          </Row>
          <Row>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u24B6');}} className={cellStyle} >&#9398;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u24B7');}} className={cellStyle} >&#9399;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u24B8');}} className={cellStyle} >&#9400;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u24B9');}} className={cellStyle} >&#9401;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u24BA');}} className={cellStyle} >&#9402;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u24BB');}} className={cellStyle} >&#9403;</Col>
          </Row>
        </Grid>
      </div>
    );
  }
});


module.exports = connect((state) => {
  return {
    overlay: state.overlay,
    map: state.map,
    currentUser: state.currentUser
  }
})(Shapes);



// WEBPACK FOOTER //
// ./src/app/components/tools/stamps/shapes.js